<template>
  <contextual-dialog
    v-bind="dialogOptions"

    :value="isAlertVisible"
    @input="handleVisibilityChange"
  />
</template>

<script>
import store from '@/services/store';
import ContextualDialog from '@/components/ContextualDialog.vue';

export default {
  name: 'AppAlert',

  components: {
    ContextualDialog,
  },

  computed: {
    isAlertVisible: () => store.state.alert?.isVisible,

    dialogOptions: () => ({
      icon: store.state.alert?.icon,
      iconColor: store.state.alert?.iconColor,
      title: store.state.alert?.title,
      message: store.state.alert?.message,
      errorList: store.state.alert?.errorList,
    }),
  },

  methods: {
    handleVisibilityChange(newState) {
      if (!newState) {
        store.dispatch('alert/hideAlert');
      }
    },
  },
};
</script>
